import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles<Theme>(() => ({
  wrapper: () => ({
    minHeight: '100%',
  }),
}));
